import React, { Component } from 'react';
import { Row, Col, Input, Modal, Select, DatePicker, Checkbox } from 'antd';
import $ from 'jquery';

const { TextArea } = Input;
const Option = Select.Option;
const { RangePicker } = DatePicker;

class NewLeave extends Component {

    constructor( props ){
        super( props );

        this.state = {
            visible: false,
            leave_type_name: 'none',
            leave_type_type: '',
            leave_type_count: 0,
            holiday: false,
            weekend: false,
            description: ''
        }

        this.handleOk = this.handleOk.bind( this );
        this.handleCancel = this.handleCancel.bind( this );    
    }

    handleOk = (e) => {

        if( this.state.leave_type_name === "" || this.state.leave_type_name === "none" ){
            this.setState({
                leave_type_name: ''
            })
            return false;
        }

        this.props.onSubmit( this.state );

        console.log( this.state );

        this.setState({ visible: false });
    
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }
    
    componentWillReceiveProps( nextProps ){
        // Clear Input
        $('input').val( '' );

        this.setState({
            visible: nextProps.onModel
        });

    }

    render() {
        return (

            <Modal
                title="Add New Leave"
                maskClosable={ false }
                visible={this.state.visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                >
                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label  className={ ( this.state.leave_type_name === '') ? 'error': '' }>Name</label>
                        <Input className={ ( this.state.leave_type_name === '') ? 'br_error': '' } 
                            onChange={ (e)=> this.setState({ leave_type_name: e.target.value }) } size="default"  />
                    </Col>
                </Row>

                <Row className="mrg_b_10" gutter={16}>
                    <Col span={ 12 }>
                        <label>Type</label>
                        <Select 
                            onChange={ (value) => this.setState({ leave_type_type: value }) }
                            style={{ width: '100%' }} >
                            <Option key="paid">Paid</Option>
                            <Option key="unpaid">Unpaid</Option>
                        </Select>
                    </Col>
                    <Col span={ 12 }>
                        <label>Leave Count</label>
                        <Input onChange={ (e) => this.setState({ leave_type_count: e.target.value }) } />
                    </Col>
                </Row>

                <Row className="mrg_b_10" gutter={16}>
                    <Col span={ 8 }>
                        <Checkbox 
                            onChange={ (e) => this.setState({ holiday: e.target.checked }) }
                            className="_center">Exclusive Holiday</Checkbox>
                    </Col>
                    <Col span={ 8 }>
                        <Checkbox 
                            onChange={ (e) => this.setState({ weekend: e.target.checked }) }
                            className="_center">Exclusive weekend</Checkbox>
                    </Col>
                </Row>

                <Row className="mrg_b_10">
                    <Col span={ 24 }>
                        <label>Description</label>
                        <TextArea 
                            onChange={ (e) => this.setState({ description: e.target.value }) }
                            rows={3} />
                    </Col>
                </Row>

            </Modal>

        )
    }
}

export default NewLeave


// WEBPACK FOOTER //
// ./src/pages/leave_type/childs/new.leave.js